import Typography from 'components/Typography';
import MedicineItem from './MedicineItem';
import { useMemoTranslations } from 'hooks/Intl';
import * as translations from 'intls/medicine';
import styles from './index.module.scss';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';

interface MedicineListProps {
  medicines: Medicine[];
  fetchStatus: LoadingStatus;
}

const MedicineList = ({ medicines, fetchStatus }: MedicineListProps) => {
  const intl = useMemoTranslations(translations);

  return (
    <div>
      {fetchStatus === 'NOT_LOADED' && (
        <Typography type="p" color="subtitle" className={styles.subtitle}>
          {intl.SEARCH_MEDICINES_BY_NAME_AND_COUNTRY}
        </Typography>
      )}
      {fetchStatus === 'LOADED' && medicines.length === 0 && (
        <Typography type="p" color="subtitle" className={styles.subtitle}>
          {intl.MEDICINE_NOT_FOUND}
        </Typography>
      )}
      {fetchStatus === 'LOADING' && (
        <div className={styles.loadingSpinner}>
          <LoadingSpinner fill />
        </div>
      )}
      {fetchStatus === 'LOADED' &&
        medicines.map(medicine => (
          <MedicineItem key={medicine.medicine_id} medicine={medicine} />
        ))}
    </div>
  );
};

export default MedicineList;
